import PropTypes from "prop-types"
import { useState } from "react"

import { getPlaceholderData } from "areas/collection/products/product-image"
import Image from "components/ui/image"

const ProductImage = ({ alt, images, index, sizes, styleCode, type }) => {
  const [hover, setHover] = useState(false)
  const productImage = hover && images[1] ? images[1] : images[0]
  const placeholder = getPlaceholderData(type)

  return (
    <div className="mx-auto">
      <Image
        alt={alt}
        className="[&.lazyload]:shimmer h-auto w-full max-w-full"
        data-cy={`collection-product-img-${styleCode}`}
        fallback={require(
          `images/collections/placeholder_masks/${
            placeholder[0]
          }_${(index % placeholder[1]) + 1}.svg`
        )}
        height="1024"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        sizes={sizes || "(max-width: 1279px) 256px, (min-width: 1280px) 300px"}
        srcSet={productImage}
        width="1024"
      />
    </div>
  )
}

ProductImage.propTypes = {
  alt: PropTypes.string,
  images: PropTypes.array,
  index: PropTypes.number,
  sizes: PropTypes.string,
  styleCode: PropTypes.string,
  type: PropTypes.string,
}

export default ProductImage
